import { render, staticRenderFns } from "./create-team.vue?vue&type=template&id=268f6b40&scoped=true&"
import script from "./create-team.vue?vue&type=script&lang=js&"
export * from "./create-team.vue?vue&type=script&lang=js&"
import style0 from "./create-team.vue?vue&type=style&index=0&id=268f6b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268f6b40",
  null
  
)

export default component.exports